// extracted by mini-css-extract-plugin
module.exports = {"container":"CardFrame_container__1zm79","backSide":"CardFrame_backSide__IYFZm","title":"CardFrame_title__EHTBA"};